import { useQuery } from "@tanstack/react-query";
import { fetchClinicInfo } from "../clinicInfo";

export function useClinicInfo() {
  return useQuery({
    queryKey: ["clinic-info"],
    queryFn: fetchClinicInfo,
  });
}
